var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobalLearning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Global-Learning--Streamline-Core-Neon",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Global Learning Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "global-learning--global-learning-education"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 645",
    stroke: "#ea7f4a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.47011 8.17761 4.02939 1.74585 -4.02939 1.74584 -4.02944 -1.74584 4.02944 -1.74585Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 346",
    stroke: "#ea7f4a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.26868 10.7198 0.00399 1.8996s0.66526 0.8804 2.19699 0.8804c1.53174 0 2.20054 -0.8804 2.20054 -0.8804l-0.0004 -1.8996",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 347",
    stroke: "#ea7f4a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.44067 12.9946V9.92358",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#215250",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.4657 6.61767C11.4884 6.41491 11.5 6.20881 11.5 6 11.5 2.96243 9.03757 0.5 6 0.5S0.5 2.96243 0.5 6c0 2.00827 1.07636 3.76514 2.68365 4.7252",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#215250",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m0.5 6 11 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#215250",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.05611 6.70036c0.02892 -0.23012 0.04947 -0.46181 0.0615 -0.69465C8.0136 3.99232 7.272 2.06417 6.00003 0.5 4.72806 2.06417 3.98646 3.99232 3.88245 6.00571c0.04175 0.80824 0.18625 1.60274 0.42656 2.36547",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalLearning);
export default __webpack_public_path__ + "static/media/Global-Learning.aff605f74f75dcfeee3275ffbfdd204b.svg";
export { ForwardRef as ReactComponent };